import { render, staticRenderFns } from "./editcourse.vue?vue&type=template&id=721b8db2&scoped=true"
import script from "./editcourse.vue?vue&type=script&lang=js"
export * from "./editcourse.vue?vue&type=script&lang=js"
import style0 from "./editcourse.vue?vue&type=style&index=0&id=721b8db2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "721b8db2",
  null
  
)

export default component.exports